import { render, staticRenderFns } from "./excel-calls-list.vue?vue&type=template&id=fa766762&scoped=true"
import script from "./excel-calls-list.vue?vue&type=script&lang=js"
export * from "./excel-calls-list.vue?vue&type=script&lang=js"
import style0 from "./excel-calls-list.vue?vue&type=style&index=0&id=fa766762&prod&lang=scss&scoped=true"
import style1 from "./excel-calls-list.vue?vue&type=style&index=1&id=fa766762&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa766762",
  null
  
)

export default component.exports